import React from 'react'
import styled from 'styled-components'

export const Spacer12px = styled.div`
    min-height: 12px;
`